import { render, staticRenderFns } from "./abilitiesBlock.vue?vue&type=template&id=5a7609e6&"
import script from "./abilitiesBlock.vue?vue&type=script&lang=js&"
export * from "./abilitiesBlock.vue?vue&type=script&lang=js&"
import style0 from "./abilitiesBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports